export function roundToHigherOrder(number) {
  if (number % 10 === 0) {
    return number;
  }
  return Math.ceil(number / 10) * 10;
}
